import { Component, Input, forwardRef, HostBinding } from "@angular/core";
import { NG_VALUE_ACCESSOR } from "@angular/forms";
import { FormBaseElement } from "../form-base-element";

@Component({
  selector: "app-radio-input",
  templateUrl: "./radio.component.html",
  styleUrls: ["./radio.component.scss"],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RadioComponent),
      multi: true,
    },
  ],
})
export class RadioComponent extends FormBaseElement {
  @Input() elementValue: any;
  /**
   *
   */
  @Input() checked: boolean = false;

  constructor() {
    super();
  }

  switch(elementValue) {
    this.value = elementValue;
  }
}
